export enum StepIds {
  Details = 'Details',
  People = 'People',
  Skills = 'Skills',
  Activate = 'Activate',
}